import PropTypes from 'prop-types'
import React from 'react'

import { TriggerUserActions } from '@/components/TriggerUserActions'

import Ui from '../../../ui'
import { hasText } from '../../../utils/helpers'
import ZentakeFormContext from '../ZentakeFormContext'

function ScaleQuestionRendererFC({
  isRequired,
  label,
  id,
  disabled,
  willShowNotAllowedCursor,
  hasError,
  handleChange,
  value,
  errorMessage,
  ...props
}) {
  return (
    <div>
      <Ui.NumericText
        disabled={disabled}
        errorLabel={errorMessage}
        hasError={hasError}
        label={label}
        onChange={handleChange}
        value={value}
        willShowNotAllowedCursor={willShowNotAllowedCursor}
        {...props}
      />
    </div>
  )
}

export const ScaleQuestionRenderer = React.memo(ScaleQuestionRendererFC)

function ScaleQuestion({ question, response, sessions }) {
  const formContext = React.useContext(ZentakeFormContext)

  const readonly = formContext.isQuestionReadonly(question)
  const willShowNotAllowedCursor =
    formContext.willShowNotAllowedCursor(question)

  const answer = formContext.getAnswer(question)
  const value = answer?.answer_raw ?? null

  const isDirty = formContext.isQuestionDirty(question)
  const isValid = formContext.isQuestionValid(question)
  const questionError = formContext.getQuestionError(question)

  const [hasError, setHasError] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState(
    'This field is required'
  )

  React.useEffect(() => {
    setHasError(
      (isDirty && question?.is_required && !isValid) || hasText(questionError)
    )
    setErrorMessage(
      questionError && typeof questionError === 'string'
        ? questionError
        : 'This field is required'
    )
  }, [isDirty, question.is_required, isValid, questionError])

  function handleChange(value) {
    formContext.onAnswerChanged(question, value)
  }

  return (
    <TriggerUserActions>
      <ScaleQuestionRenderer
        data-form-id={response?.form?.id}
        data-packet-id={
          sessions?.fillResponseCustomer?.packetResponse?.packet?.id
        }
        data-response-id={response?.id}
        disabled={readonly}
        errorMessage={errorMessage}
        handleChange={handleChange}
        hasError={hasError}
        id={question.id}
        isRequired={question.is_required}
        label={question.text}
        value={value}
        willShowNotAllowedCursor={willShowNotAllowedCursor}
      />
    </TriggerUserActions>
  )
}

ScaleQuestion.propTypes = {
  question: PropTypes.object.isRequired,
}

export default ScaleQuestion
